'use strict';

angular.module('shiftTraderApp')
  .directive('cwpEmployeeListItem', function () {
    var MAX_NUM_RETRIES = 3;

    return {
      templateUrl: 'views/directives/cwpEmployeeListItem.html',
      restrict: 'EA',
      scope: {
        emp: '=',
        wpidExclusion: '=',
        shift: '='
      },
      controller: ['$scope', '$timeout','WorkPeriods', 'TimeService', '$rootScope', '$log', '$controller',
                    'AvailabilityService', 'WeightCalculationService', 'ShepherdTourService',
                    function ($scope, $timeout, WorkPeriods, TimeService, $rootScope, $log, $controller,
                              AvailabilityService, WeightCalculationService, ShepherdTourService) {

        var baseCtrl = $controller('BaseSmartCWPListItemCtrl', {$scope: $scope});

        $scope.emp._workPeriodsNotLoaded = true;
        $scope.emp._workPeriods = [];

        if ($scope.emp._scheduledToWork) {
          $scope.state.isAssignedToShift = true;
        }

        var lastWeek;

        var emitCalculationState = function(noReason) {
          $scope.$emit('sa:cwpEmployeeListingCalculationState', {
            type: 'workPeriod',
            id: null,
            state: $scope.state.busyCalculating,
            user_id: $scope.emp.id
          });
        };

        var calcWeightingWithWorkPeriodsAlreadyLoaded = function() {
          $scope.emp._overlap = WeightCalculationService.calculateOverlapWithExistingWorkPeriods(
            $scope.emp._workPeriods,
            $scope.shift.range_twix
          );
          //console.log($scope.emp.name + ' OV:' + $scope.emp._overlap.weight);

          if ( !$scope.emp._workPeriodsNotLoaded ) {
            var targetHoursToUse = $scope.emp.$effectiveAvailabilitySet($scope.shift.start_time) ? $scope.emp.$effectiveAvailabilitySet($scope.shift.start_time).target_hours : 20;
            $scope.emp._targetHoursWeighting = WeightCalculationService.calculateTargetHoursWeighting(
              targetHoursToUse,
              $scope.hoursPerWeek[2],
              currentTwixIntersectingWeekLengthInHours);

            $scope.emp._overtimeWeighting = WeightCalculationService.calculateOvertimeWeighting(
              $scope.emp.$curMemb().organization.organization_config.overtime_threshold_hours,
              $scope.hoursPerWeek[2],
              currentTwixIntersectingWeekLengthInHours);

            $scope.emp._multiShift = WeightCalculationService.calculateMultiShift(
              $scope.emp._workPeriods,
              $scope.currentDateTwix,
              {
                $isWorkPeriod: function() {return false},
                id: null,
                range_twix: $scope.shift.range_twix
              });

            $scope.emp._connectingShift = baseCtrl.doConnectingShiftDetection({
              $isWorkPeriod: function() {return false},
              id: null,
              range_twix: $scope.shift.range_twix
            }, $scope.currentDateTwix, $scope.emp._workPeriods);

            $scope.emp.availabilityIndex = $scope.emp._overlap.weight + $scope.emp._availabilityIntersection.weight +
            $scope.emp._overtimeWeighting.weight + $scope.emp._targetHoursWeighting +
            $scope.emp._multiShift.weight;
          }

          $scope.emp._hoursThisWeek = $scope.hoursPerWeek[2];

          if ($scope.emp._scheduledToWork && !$scope.emp._workPeriodsNotLoaded) {
            $scope.numHoursThisWeek = $scope.emp._hoursThisWeek;
            $scope.emp._hoursThisWeek = $scope.hoursPerWeek[2];
            $scope.numHoursThisWeek += $scope.shift.range_twix.length('minutes') / 60.0;
          } else if (!$scope.emp._workPeriodsNotLoaded) {
            $scope.numHoursThisWeek = $scope.emp._hoursThisWeek;
            $scope.emp._hoursThisWeek = $scope.hoursPerWeek[2];
          }
          $scope.state.busyCalculating = false;
          emitCalculationState();
        };


        var lastWatchIdValue;
        var currentTwixLengthInHours, currentTwixIntersectingWeekLengthInHours;
        $scope.$watch('shift._watchId', function(newVal, oldVal) {
          // console.log('WATCH: shift._watchId ', $scope.emp.id, ': ', newVal, oldVal);
          $scope.state.currentShiftWatchId = newVal;

          if (newVal && newVal === lastWatchIdValue) {
            return;
          }

          lastWatchIdValue = newVal;

          // If the request for WorkPeriods (in onShiftChange) fails, it
          // needs to be rerun to hopefully load them the next time. So,
          // we set the number of retries to zero. The actual retry code is
          // in the failing case of the WorkPeriod.getByUserId() call below.
          $scope.state.numRetries = 0;
          onShiftChange(newVal);
        });

        function onShiftChange(uniqueId) {
          // update their training position and matching users position
          $scope.emp._isTrainingInPosition = $scope.emp.$isTrainingInPosition($scope.shift.position_id);
          $scope.emp._matchingUsersPosition = lodash.find($scope.emp.users_positions, function(up) {
            return up.position_id === parseInt($scope.shift.position_id);
          });


          $scope.state.busyCalculating = true;
          emitCalculationState();

          baseCtrl.calcCurrentDate();

          // Always calculate the availability intersection
          // -- this can be done without workPeriod data for the user
          // -- should be fairly quick
          calculateAvailabilityIntersection($scope.shift.range_twix);
          //console.log($scope.emp._availabilityIntersection);
          //console.log($scope.emp.name + ' AI:' + $scope.emp._availabilityIntersection.weight);

          //if the week of interest changes then retrieve the data you need
          var newWeekNum = TimeService.getWorkWeekNumberFromMoment($scope.shift.start_time);

          $scope.weekRanges = [];
          var twoWeeksAgoSunday = TimeService.getWeekTwixFromMoment($scope.currentDate, 0, 0, true).start.subtract(2, 'weeks');
          for(var i=-2; i <= 2; i++) {
            temp = moment(twoWeeksAgoSunday).twix(twoWeeksAgoSunday.add(1, 'weeks'));
            $scope.weekRanges.push(temp);
          }

          currentTwixLengthInHours = $scope.shift.range_twix.length('minutes') / 60.0;
          currentTwixIntersectingWeekLengthInHours = $scope.shift.range_twix.intersection($scope.weekRanges[2]).length('minutes') / 60.0;

          if (lastWeek !== newWeekNum || $scope.emp._workPeriodsNotLoaded) {
            // lastWeek = newWeekNum;
            var temp = TimeService.getWeekTwixFromMoment($scope.shift.start_time, 0, 0, true).start;
            var data = {
              start_time: moment(temp).subtract(2, 'weeks').utc().format(),
              end_time: temp.day(7).add(1, 'weeks').utc().format(),
              view: 'min'
            };

            $scope.weekRanges = [];
            var twoWeeksAgoSunday = moment(data.start_time);
            for(var i = -2; i <= 2; i++) {
              temp = moment(twoWeeksAgoSunday).twix(twoWeeksAgoSunday.add(1, 'weeks'));
              $scope.weekRanges.push(temp);
            }

            WorkPeriods.getByUserId($scope.emp.id, data)
              .then(function(workPeriods) {
                // Set lastWeek to newWeekNum ONLY in the case
                // where the request actually succeeded.
                //
                // Previously, this was done above the WorkPeriods.getByUserId
                // request regardless of pass/fail. In the event, of a
                // failure, our retries were being passed through to the
                // else-case rather than actually rerunning the query.
                lastWeek = newWeekNum;

                // For the retry loop. If we are in the middle of a retry
                // loop and the watch gets triggered, we need to abort the
                // retry loop on the success case.
                if ($scope.state.currentShiftWatchId != uniqueId) {
                  return;
                }

                $scope.state.busyCalculating = true;
                // console.log(workPeriods);
                if (lodash.isUndefined($scope.wpidExclusion) || $scope.wpidExclusion === false) {
                  $scope.emp._workPeriods = workPeriods;
                } else {
                  //filter out the workPeriod id exclusion
                  $scope.emp._workPeriods = lodash.filter(workPeriods, function(wp) {
                    return wp.id !== parseInt($scope.wpidExclusion);
                  });
                }
                // Calculate the overlap of the currentTwix with the exsting workPeriods
                $scope.emp._overlap = WeightCalculationService.calculateOverlapWithExistingWorkPeriods(
                    $scope.emp._workPeriods,
                    $scope.shift.range_twix);
                //console.log($scope.emp.name + ' OV:' + $scope.emp._overlap.weight);

                $scope.hoursPerWeek = calculateHoursPerWeek();

                $scope.emp._hoursThisWeek = $scope.hoursPerWeek[2];

                if ($scope.emp._scheduledToWork && !$scope.emp._workPeriodsNotLoaded) {
                  $scope.numHoursThisWeek = $scope.emp._hoursThisWeek;
                  $scope.emp._hoursThisWeek = $scope.hoursPerWeek[2];
                  $scope.numHoursThisWeek += $scope.shift.range_twix.length('minutes') / 60.0;
                  $scope.numHoursThisWeek = $scope.emp._hoursThisWeek;
                  $scope.emp._hoursThisWeek = $scope.hoursPerWeek[2];
                }

                $scope.emp._hoursThisWeek = $scope.hoursPerWeek[2];
                if ($scope.emp._scheduledToWork) {
                  $scope.numHoursThisWeek = $scope.hoursPerWeek[2] + currentTwixIntersectingWeekLengthInHours;
                } else {
                  $scope.numHoursThisWeek = $scope.hoursPerWeek[2];
                }
                $scope.emp._workPeriodsNotLoaded = false;

                var targetHoursToUse = $scope.emp.$effectiveAvailabilitySet($scope.shift.start_time) ? $scope.emp.$effectiveAvailabilitySet($scope.shift.start_time).target_hours : 20;
                $scope.emp._targetHoursWeighting = WeightCalculationService.calculateTargetHoursWeighting(
                    targetHoursToUse,
                    $scope.hoursPerWeek[2],
                    currentTwixIntersectingWeekLengthInHours);

                var overtimeHoursToUse = $scope.emp.$curMemb().organization.organization_config.overtime_threshold_hours;
                $scope.emp._overtimeWeighting = WeightCalculationService.calculateOvertimeWeighting(
                    overtimeHoursToUse,
                    $scope.hoursPerWeek[2],
                    currentTwixIntersectingWeekLengthInHours);

                $scope.emp._multiShift = WeightCalculationService.calculateMultiShift(
                    $scope.emp._workPeriods,
                    $scope.currentDateTwix,
                    {
                      $isWorkPeriod: function() {return false},
                      id: null,
                      range_twix: $scope.currentDateTwix
                    });

                $scope.emp._connectingShift = baseCtrl.doConnectingShiftDetection({
                  $isWorkPeriod: function() {return false},
                  id: null,
                  range_twix: $scope.shift.range_twix
                }, $scope.currentDateTwix, $scope.emp._workPeriods);

                // Combine work_period overlap, availability intersection (incl. blackouts), target hours, overtime
                $scope.emp.availabilityIndex = $scope.emp._overlap.weight + $scope.emp._availabilityIntersection.weight +
                                               $scope.emp._targetHoursWeighting + $scope.emp._multiShift.weight - $scope.emp._connectingShift.weight;


                // if an employees target hours is > overtime hour threshold AND we are not penalizing that then don't add it in
                // line below is the exact reverse...
                if ($scope.emp.$curMemb().organization.organization_config.penalize_target_gt_overtime === true || targetHoursToUse < overtimeHoursToUse) {
                  $scope.emp.availabilityIndex += $scope.emp._overtimeWeighting.weight;
                }

                //turn off activity sign
                $scope.state.busyCalculating = false;
                emitCalculationState();
              }, function(response) {

                // In the event of a failure to load the WorkPeriods,
                // we will rerun this API call n number of times before
                // finally giving up. It will be recalled in the case where:
                //
                // 1. The current watch ID (see the $watch for shift._watchId)
                //    is the same as the one run before. In other words, the
                //    time or position has not been changed and we are still
                //    working on the same request(s).
                //  -- AND --
                // 2. The current number of retries is less than the
                //    maximum number of retries allowed. We can't let this
                //    run forever and ever.
                // console.log('Failed to fetch WorkPeriods', response);
                if ($scope.state.currentShiftWatchId == uniqueId && $scope.state.numRetries < MAX_NUM_RETRIES) {
                  // console.log('Recalling onShiftChange()');
                  $scope.state.numRetries += 1;
                  onShiftChange();
                } else {
                  // console.log('Reached maximum limit of recalls for onShiftChange()');
                }
              });

            // TODO: remove line below.  I don't think this needs to be done twice
            //calculateAvailabilityIntersection($scope.shift.range_twix);

          } else {
            //this else is if the week has NOT changed
            calcWeightingWithWorkPeriodsAlreadyLoaded();
          }


          // until the workPeriods are done loading just use user availability_rules
          if ($scope.emp.availabilityIndex === undefined) {
            $scope.emp.availabilityIndex = $scope.emp._availabilityIntersection.weight;
          }
        } //end of onShiftChange() a.k.a. shift._watchId $watch

        var calculateHoursPerWeek = function() {
          // use date for beginning of work week to classify hours in each week
          // loop over workPeriods to do this
          var hoursPerWeek = [];
          lodash.forEach($scope.weekRanges, function(weekRange, ind) {
            hoursPerWeek[ind] = 0; // initialize to 0 just in case they don't have any workPeriods
            if ($scope.emp._workPeriods.length > 0) {
              hoursPerWeek[ind] = lodash.reduce(lodash.map($scope.emp._workPeriods, function(wp) {
                  //console.log('calcHoursPerWeek:', wp.id, wp.user && wp.user.name, parseInt($scope.wpidExclusion), wp.id === parseInt($scope.wpidExclusion));
                if (weekRange.overlaps(wp.range_twix) && wp.id !== parseInt($scope.wpidExclusion)) {
                  return Math.abs(weekRange.intersection(wp.range_twix).length('minutes')) / 60.0;
                } else {
                  return 0;
                }
              }),
              function(num, sum) {
                return num + sum;
              });
              //console.log('calcHoursPerWeek: ', ind , $scope.emp.name, hoursPerWeek[ind]);
            }
          });
          //console.log(hoursPerWeek);
          return hoursPerWeek;
        };

        var calculateAvailabilityIntersection = function(twix) {
          $scope.emp._availabilityIntersection = $scope.emp.$overlapsWithAvailability(twix);
          $scope.emp._blackout = Math.max.apply(Math, lodash.map($scope.emp._availabilityIntersection.data, function(v) {
            return (v.type === 'single' ? 1 : 0) + (v.approved && v.type === 'single' ? 2 : 0);
          }));

          if ($scope.emp._blackout === -Infinity) {
            $scope.emp._blackout = 0;
          }
        };

        $scope.addUserToShift = function() {
          $scope.$emit('addUserToShift', $scope.emp);
          ShepherdTourService.triggerEvent('cwpEmployeeListItemScheduled');
        };

        $scope.unassignUserFromShift = function() {
          $scope.$emit('unassignUserFromShift');
        };

        $scope.$on('sa:checkShiftAssignments', function() {
          if ($scope.state.isAssignedToShift != !!$scope.emp._scheduledToWork) {
            $scope.state.isAssignedToShift = !!$scope.emp._scheduledToWork;
            calcWeightingWithWorkPeriodsAlreadyLoaded();
          }

        });

      }],
      link: function(scope, elem, attrs, ctrl) {
        var colorBarLeft = $(elem).find('.color_bar_left');

        scope.setColorClass = function(cls) {
          colorBarLeft.removeClass(['gray_gradient', 'charcoal_gradient', 'green_gradient', 'orange_gradient', 'rouge_gradient'].join(' '));
          colorBarLeft.addClass(cls);
        };
      }
    };
  });
